import { React } from '../../../lib';
import { StubMessage } from './ui-options';
export const ReportJobGlobalParams = (props) => {
    if (false) {
        console.log(props);
    }
    return React.createElement(StubMessage, { msg: "Coming soon" });
};
//# sourceMappingURL=ui-globals.js.map